/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('ReindexController', function ($scope, $state, $stateParams, $rootScope, $filter, Principal, CollectionService, PlaybackStats, AssetStats,
                                                         DropOffStats, DeviceOSMetrics, UserStatsByFrequency, $anchorScroll, $location, $sce) {

        Principal.identity().then(function(account) {
            $scope.reindexMM = function () {
                CollectionService.ReIndexMediaManager.get({}, function (collection) {
                });
            }
        });
    });
